import { UIHeading3 } from '@cian/ui-kit';

import { type FC, type ReactNode } from 'react';

import { WrapElementsSpacer } from '@/packages/shared-ui';
import { prettyPluralize } from '@/packages/utils/prettyPluralize';

import styles from './HeaderSEOBlock.css';

type HeaderSEOBLockProps = {
  offersCount: number;
  title: ReactNode;
  sortButton: ReactNode;
  toMapButton: ReactNode;
  withFadeTitle?: boolean;
};

export const HeaderSEOBlock: FC<HeaderSEOBLockProps> = props => {
  const { title, offersCount, sortButton, toMapButton } = props;

  return (
    <div className={styles['header-container']}>
      <div className={styles['header-wrapper']}>{title}</div>
      <WrapElementsSpacer horizontalSpace={8} verticalSpace={8}>
        <UIHeading3>
          <span data-testid="OffersCount">
            {`Найдено ${prettyPluralize(offersCount, ['объявление', 'объявления', 'объявлений'])}`}
          </span>
        </UIHeading3>
        {sortButton}
        {toMapButton}
      </WrapElementsSpacer>
    </div>
  );
};
